import type { ExcIceJobV1JobKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const ICE_JOB_BASE_PATH = getResolvedPath('/clearing/vendor/ice/job');

export const getIceJobPath: EntityPathBuilder<ExcIceJobV1JobKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return ICE_JOB_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.jobId) {
        return undefined;
      }

      return getResolvedPath(`${ICE_JOB_BASE_PATH}/$jobId`, context.keys);
    }
  }
};

export function getIceJobDetailPath(jobId: string | undefined) {
  if (!jobId) {
    return undefined;
  }

  return getIceJobPath({ kind: 'detail', keys: { jobId } });
}
